import { Injectable, signal } from '@angular/core';
import { firstValueFrom, of, switchMap } from 'rxjs';

import { SessionStorageService } from '@core/services/session-storage.service';
import { AppData } from '@core/services/app-data.service';
import { config } from '@core/services/request-url.service';
import { HttpApiService } from '@core/auth/http-api.service';
import { UserService } from '@core/auth/user/user.service';
import { StorageService } from '@core/storage-module/storage.service';
import { MenuApiResponse } from './menu-model';
import { WalletStore } from '@core/stores/wallet.store';

@Injectable({ providedIn: 'root' })
export class DashboardService {

  sidebarData = signal<MenuApiResponse | null>(this._StorageService.getItem('sidebar') ?? null);

  constructor(
    private _HttpApiService: HttpApiService,
    private storage: SessionStorageService,
    private _UserService: UserService,
    private _WalletStore: WalletStore,
    private readonly _StorageService: StorageService
  ) { }

  fetchDashboardData(refresh: boolean = false) {
    const sidebarData = this.sidebarData();
    if (sidebarData && !refresh) return of(sidebarData);
    return this._HttpApiService.post(config.sidebar.url, {}).pipe(
      switchMap((res: MenuApiResponse) => {
        if (res.statuscode == 200) {
          this._StorageService.setItem('sidebar', res);
          this.sidebarData.set(res);
          AppData.dashboardSubMenu.next(res.menu_array);
          return of(res);
        }
        return of(null);
      })
    );
  }

  resetSideBar(): void {
    this.sidebarData.set(null);
    this._StorageService.removeItem('sidebar');

  }

  // async getDashboardData(): Promise<any> {
  //   const resp: any = await firstValueFrom(
  //     this._HttpApiService.post(config.sidebar.url, {})
  //   );

  //   if (!resp) {
  //     AppData.sidebarData.next(null);
  //     return [];
  //   }

  //   AppData.sidebarData.next(resp);
  //   AppData.dashboardSubMenu.next(resp.menu_array);
  //   return resp;
  // }

  async userBalance() {
    this._WalletStore.fetchWallet(true);

    // const data = {
    //   type: 'wallet',
    //   agentbalance: this._UserService.getPartialData("data.agentbalance")
    // };

    // const resp: any = await firstValueFrom(
    //   this._HttpApiService.post(config.dashboard.amount.url, data)
    // );

    // if (resp?.statuscode === 200) {
    //   this.storage.setItem('userWalletAmount', resp.balance_enquiry);
    //   // AppData.allBanlances.next(resp.balance_enquiry);
    // }
  }

  async fetchBannerData(): Promise<any> {
    const storedBanners = this.storage.getItem('banners');
    if (storedBanners) return JSON.parse(storedBanners);

    const observableBanners = AppData.banners.getValue();
    if (observableBanners) return observableBanners;

    return this.getBanners();
  }

  async getBanners(): Promise<any> {
    const resp: any = await firstValueFrom(
      this._HttpApiService.post(config.dashboard.banners.url, { type: 'wallet' })
    );

    if (resp?.statuscode !== 200) {
      throw new Error('Failed to fetch banners');
    }

    this.storage.setItem('banners', JSON.stringify(resp));
    AppData.banners.next(resp);
    return resp;
  }
}
